<template>
  <b-modal id="clinic-provider-product" ref="modal" :title="dialog_title" hide-footer>
    <div class="form-group row">
      <div class="col-md-2">
        <input type="text" class="form-control" id="product_name" v-model="name">
        <label for="product_name" class="wabident-info">Nombre</label>
      </div>

      <div class="col-md-2">
        <select class="custom-select" v-model="type" id="provider_product_type">
          <option value="physical">Físico</option>
          <option value="virtual">Virtual</option>
        </select>
        <label for="provider_product_type" class="wabident-info">Tipo</label>
      </div>

      <div class="col-md-3">
        <select class="custom-select" v-model="provider_family_id" id="provider_family_id">
          <option :value="null">Elige Familia ...</option>
          <option :value="family.id" v-for="family in families" :key="family.id">{{ family.name }}</option>
        </select>
        <label for="provider_family_id" class="wabident-info">Familia (Obligatoria)</label>
      </div>

      <div class="col-md-2">
        <input class="form-control" type="number" v-model="cost" id="provider_product_cost" step="0.01">
        <label for="provider_product_cost" class="wabident-info">Coste Unitario (€)</label>
      </div>

      <div class="col-md-2">
        <select class="custom-select" v-model="vat" id="provider_vat">
          <option :value="0">Exento</option>
          <option :value="4">4%</option>
          <option :value="10">10%</option>
          <option :value="21">21%</option>
          <option :value="7">IGIC 7%</option>
        </select>
        <label for="provider_product_cost" class="wabident-info">IVA(%)</label>
      </div>
    </div>

    <div class="form-group row" v-if="type == 'physical'">
      <div class="col-12">
        <h6>STOCKS</h6>
      </div>

      <div class="col-md-4">
        <input class="form-control" type="number" v-model="current_stock" id="provider_current_stock" step="1">
        <label for="provider_current_stock" class="wabident-info">Stock Actual</label>
      </div>

      <div class="col-md-4">
        <input class="form-control" type="number" v-model="min_stock" id="provider_min_stock" step="1">
        <label for="provider_min_stock" class="wabident-info">Stock Mínimo (Para Alertas)</label>
      </div>

      <div class="col-md-4">
        <input class="form-control" type="number" v-model="order_quantity" id="provider_min_stock" step="1">
        <label for="provider_order_quantity" class="wabident-info">Pedido mínimo (Uds)</label>
      </div>
    </div>


    <div class="form-group row">
      <div class="col-12">
        <h6>INFORMACIÓN ADICIONAL</h6>
      </div>
      <div class="col-12">
        <textarea class="form-control" id="provider_product_notes" v-model="notes"></textarea>
        <label class="wabident-info" for="provider_product_notes">Observaciones</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col d-flex justify-content-around" style="gap:10px">
        <button v-if="is_editing" type="button" class="btn btn-wabident red" @click="onDelete"
          :disabled="is_loading || !is_valid"><i class="fas fa-trash"></i> Borrar</button>
        <button type="button" class="btn btn-wabident" @click="onSubmit" :disabled="is_loading">{{ btn_title
        }}</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      product: null,
      is_loading: false,
      name: null,
      provider_family_id: null,
      type: 'physical',
      notes: null,
      cost: 0,
      current_stock: 0,
      min_stock: 0,
      order_quantity: 0,
      vat: 0,
    };
  },
  computed: {
    is_valid() {
      return this.provider_family_id !== null;
    },
    families() {
      return this.clinic ? this.clinic.provider_families : [];
    },
    is_editing() {
      return this.product != null;
    },
    dialog_title() {
      return this.is_editing ? 'Editar Material' : 'Crear Material';
    },
    btn_title() {
      return this.is_editing ? 'Modificar' : 'Crear';
    },
    ...mapGetters(['clinic', 'errorwindow', 'msgwindow'])
  },
  methods: {
    showNew() {
      this.is_loading = false;
      this.product = null;
      this.provider_family_id = null;
      this.type = 'physical';
      this.notes = null;
      this.cost = 0;
      this.current_stock = 0;
      this.min_stock = 0;
      this.order_quantity = 0;
      this.vat = 0;
      this.$refs.modal.show();
    },
    showEdit(product) {
      this.product = product;
      this.name = product.name;
      this.provider_family_id = product.provider_family_id;
      this.type = product.type;
      this.notes = product.notes;
      this.cost = product.cost;
      this.current_stock = product.current_stock;
      this.min_stock = product.min_stock;
      this.order_quantity = product.order_quantity;
      this.vat = product.vat;
      this.is_loading = false;
      this.$refs.modal.show();
    },
    onSubmit() {
      if (this.is_loading) {
        return;
      }

      this.is_loading = true;

      const uri = this.is_editing ? `/clinic/${this.clinic.id}/provider_product/${this.product.id}` : `/clinic/${this.clinic.id}/provider_product`;
      let params = {
        name: this.name,
        provider_family_id: this.provider_family_id,
        type: this.type,
        notes: this.notes,
        cost: this.cost,
        current_stock: this.current_stock,
        min_stock: this.min_stock,
        order_quantity: this.order_quantity,
        vat: this.vat,
      };

      if (this.is_editing) {
        params['_method'] = 'patch';
      }

      axios.post(uri, params).then((response) => {
        let data = response.data;
        if (data.error) {
          this.errorwindow.show('Error', data.error);
        } else {
          this.$emit('submit');
          this.$refs.modal.hide();
        }
      }).catch((error) => {
        console.log(error);
        this.errorwindow.show('Error', 'Error modificando Producto. Por favor, consulte con el Administrador');
      }).then(() => {
        this.is_loading = this.false;
      });

    },
    onDelete() {

      if (this.is_loading) {
        return;
      }

      this.is_loading = true;
      const uri = `/clinic/${this.clinic.id}/provider_product/${this.product.id}`;

      let params = {
        _method: 'delete',
      };

      axios.post(uri, params).then((response) => {
        let data = response.data;
        if (data.error) {
          this.errorwindow.show('Error', data.error);
        } else {
          this.$emit('submit');
          this.$refs.modal.hide();
        }
      }).catch((error) => {
        console.log(error);
        this.errorwindow.show('Error', 'Error borrando Producto. Por favor, consulte con el Administrador');
      }).then(() => {
        this.is_loading = false;
      });
    },
  }
}
</script>

<style lang="scss">
#clinic-provider-product {
  .modal-dialog {
    max-width: 1440px;
  }
}
</style>
